<script setup lang="ts">
defineProps<{ cardNumber: string }>();
</script>

<template>
  <span>**** **** **** {{ cardNumber }}</span>
</template>
